import React from "react";
import Select from "../form/Select";

const LimitSelect = ({ value = 10, allValue, onChange = () => {} }) => {
  return (
    <Select
      selectedValue={value}
      dropdownData={[
        // allValue && {
        //   name: "All Items",
        //   value: allValue,
        // },
        { name: "5 Items", value: 5 },
        { name: "10 Items", value: 10 },
        { name: "20 Items", value: 20 },
        { name: "30 Items", value: 30 },
        { name: "50 Items", value: 50 },
        { name: "100 Items", value: 100 },
      ]?.filter(Boolean)}
      setSelectedValue={(val) => {
        onChange(val);
      }}
    />
  );
};

export default LimitSelect;
